<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <b-form-group :label-cols="5" label="Name" :state="stateForField('name')" :invalid-feedback="errorForField('name')" label-class="text-right">
            <b-form-input v-model="allowableFeeSchedule.name"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Effective Date" :state="stateForField('effectiveDate')" :invalid-feedback="errorForField('effectiveDate')" label-class="text-right">
            <b-form-datepicker format="MM/dd/yyyy" :use-utc="true" :typeable="true" class="form-control datepicker" v-model="allowableFeeSchedule.effectiveDate"></b-form-datepicker>
          </b-form-group>
          <b-form-group :label-cols="5" label="Discount Strategy" :state="stateForField('discountStrategy')" :invalid-feedback="errorForField('discountStrategy')" label-class="text-right">
            <b-select class="input-border" v-model="allowableFeeSchedule.discountStrategy" :options="discountStrategyOptions"></b-select>
          </b-form-group>
          <b-form-group :label-cols="5" label="Self Pay" :state="stateForField('selfPay')" :invalid-feedback="errorForField('selfPay')" label-class="text-right">
            <b-form-radio-group v-model="allowableFeeSchedule.isSelfPay" class="pt-2" :options="yesNoOptions"/>
          </b-form-group>
          <b-form-group :label-cols="5" label="Medicare Multiplier" :state="stateForField('defaultMedicareMultiplier')" :invalid-feedback="errorForField('defaultMedicareMultiplier')" label-class="text-right">
            <b-input-group append="%"><b-form-input  v-model="allowableFeeSchedule.defaultMedicareMultiplier"></b-form-input></b-input-group>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveFeeSchedule()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import _ from 'lodash'
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'AllowableFeeSchedulesModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editAllowableFeeSchedule: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        allowableFeeSchedule: {},
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        discountStrategyName: 'Click to select',
        isSaving: false,
        discountStrategyOptions: [
          { value: null, text: '100%' },
          { value: 'FirstFull50Remaining', text: '100% 50%' },
          { value: 'FirstFullSecondAt50ThenZero', text: '100% 50% 0%' },
          { value: 'Discount25EachToZero', text: '100% 50% 25% 0%' },
          { value: 'Discount25Each', text: '100% 50% 25%' },
          { value: 'All60', text: '60%' },
          { value: 'Discount25EachWithDouble25', text: '100% 50% 25% 25% 0%' },
          { value: 'FirstFull2At50ThenZero', text: '100% 50% 50% 0%' }
        ]
      }
    },

    watch: {
      editAllowableFeeSchedule (newValue) {
        if (newValue.organizationAllowableFeeScheduleId) {
          this.allowableFeeSchedule = _.clone(newValue)
          this.allowableFeeSchedule.defaultMedicareMultiplier *= 100
        } else {
          this.allowableFeeSchedule = {}
        }
      }
    },

    computed: {
      title () {
        if (this.allowableFeeSchedule && this.allowableFeeSchedule.organizationAllowableFeeScheduleId) {
          return 'Edit Allowable Fee Schedule'
        }
        return 'Create Allowable Fee Schedule'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.allowableFeeSchedule.name) {
          this.addErrorForField('name', 'You must choose a name')
        }

        if (!this.allowableFeeSchedule.effectiveDate) {
          this.addErrorForField('effectiveDate', 'You must choose a date')
        }

        if (!this.allowableFeeSchedule.defaultMedicareMultiplier) {
          this.addErrorForField('defaultMedicareMultiplier', 'You must choose a default medicare multiplier')
        }

        return !this.hasErrors()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      saveFeeSchedule () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        const feeSchedule = _.assign({}, this.allowableFeeSchedule)
        if (feeSchedule.defaultMedicareMultiplier) {
          feeSchedule.defaultMedicareMultiplier /= 100
        }
        this.isSaving = true
        api.post('Dashboard/AllowableFeeSchedules', feeSchedule).then(response => {

          this.isSaving = false
          this.$emit('updated', response)
          this.allowableFeeSchedule = {}
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }
  }
</script>
